var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function LeftArrow(_a) {
    var _b = _a.className, className = _b === void 0 ? '' : _b, _c = _a.style, style = _c === void 0 ? {} : _c, props = __rest(_a, ["className", "style"]);
    return (_jsxs("svg", __assign({}, props, { className: className, style: style, version: '1.1', id: 'Capa_1', xmlns: 'http://www.w3.org/2000/svg', xmlnsXlink: 'http://www.w3.org/1999/xlink', x: '0px', y: '0px', width: '408px', height: '408px', viewBox: '0 0 408 408', xmlSpace: 'preserve' }, { children: [_jsx("g", { children: _jsx("g", __assign({ id: 'arrow-back' }, { children: _jsx("path", { d: 'M408,178.5H96.9L239.7,35.7L204,0L0,204l204,204l35.7-35.7L96.9,229.5H408V178.5z' }, void 0) }), void 0) }, void 0),
            _jsx("g", {}, void 0),
            _jsx("g", {}, void 0),
            _jsx("g", {}, void 0),
            _jsx("g", {}, void 0),
            _jsx("g", {}, void 0),
            _jsx("g", {}, void 0),
            _jsx("g", {}, void 0),
            _jsx("g", {}, void 0),
            _jsx("g", {}, void 0),
            _jsx("g", {}, void 0),
            _jsx("g", {}, void 0),
            _jsx("g", {}, void 0),
            _jsx("g", {}, void 0),
            _jsx("g", {}, void 0),
            _jsx("g", {}, void 0)] }), void 0));
}
